// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormChangeStatusJob } from '~/utils/interface/job';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      status: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
    })
    .required();
};

export const defaultValuesForm: IFormChangeStatusJob = {
  status: EMPTY_STRING,
};
